module.exports = __webpack_public_path__ + "img/avatar7.1c6be855.png";